import { RevisionModel } from '@abb-procure/data';
import {
  Component,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { DatePipe } from '../../pipes/date.pipe';
import { NgChanges } from '../../utilities/angular-types.util';
import { StatusBadge } from '../status-badge/status-badge.component';

@Component({
  selector: 'procure-revisions-log',
  templateUrl: './revisions-log.component.html',
  styleUrl: './revisions-log.component.scss',
  imports: [
    MatTable,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderCellDef,
    MatCell,
    MatRow,
    MatCellDef,
    MatColumnDef,
    MatNoDataRow,
    MatRowDef,
    MatHeaderRowDef,
    RouterLink,
    StatusBadge,
    DatePipe,
    QuicklinkDirective,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RevisionsLog implements OnChanges {
  @Input() revisions: RevisionModel[] = [];

  readonly displayedColumns: string[] = [
    'revisionIndex',
    'statusName',
    'created',
  ];

  dataSource: MatTableDataSource<RevisionModel> = new MatTableDataSource([]);

  ngOnChanges(changes: Partial<NgChanges<RevisionsLog>>): void {
    if (
      'revisions' in changes &&
      changes.revisions?.previousValue !== changes.revisions?.currentValue
    ) {
      this.dataSource.data = [...(changes.revisions?.currentValue ?? [])];
    }
  }
}
